import { SyncIcon } from '@mm/icons';
import { ReactComponent as InstagramIcon } from 'assets/instagram.svg';
import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import * as allPermissions from '@mm/constants/facebook-permissions';
import facebookSDKActions from '@mm/state/actions/facebookActions';
import { useInstagramCRUDActions } from '@mm/state/actions/InstagramCRUDActions';
import ConnectedPageModel from '@mm/state/model/ConnectedPageModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { Status } from '@mm/components';
import SettingSection from '../../../../components/SettingSection/SettingSection';
import { getConnectionStatus } from '../FacebookConnectionStatus/FacebookConnectionStatus';
import './InstagramAccountConnectionStatus.pcss';

type Props = {
  page: ConnectedPageModel;
};

export const InstagramAccountConnectionStatus = (props: Props) => {
  const { page } = props;
  const { deactivateIG } = useInstagramCRUDActions();
  const { openDisconnectPageModal } = useModalActions();
  const [connectionStatus, connectionColor] = getConnectionStatus(page);
  const statusText = connectionStatus === 'OK' ? 'Connected' : connectionStatus;
  const dispatch = useDispatch();
  const { activateIG } = useInstagramCRUDActions();
  const permissions = allPermissions.getArrayOfPermissions(
    allPermissions.INSTAGRAM_PERMISSIONS,
  );
  const onClickDisconnect = () => {
    openDisconnectPageModal(page, true, () => deactivateIG(page.id));
  };
  const refreshIGConnection = async () => {
    await dispatch(
      facebookSDKActions.requestPermissionsWithManualFlowFallback(permissions),
    );
    if (page) {
      await activateIG(page.id);
    }
  };

  const statusClassname = classNames(
    'facebook-connection-status__status-text',
    {
      'facebook-connection-status__status-text--error':
        connectionStatus !== 'OK',
    },
  );

  return (
    <SettingSection title="">
      <div className="ig-account-connection-status__title-wrapper">
        <InstagramIcon className="ig-account-connection-status__ig-icon" />
        <div className="ig-account-connection-status__status">
          Instagram Connection Status:
        </div>
        <Status
          status={statusText}
          color={connectionColor}
          className={statusClassname}
        />
      </div>
      <div className="ig-account-connection-status__actions">
        <PrimaryButton
          leftIcon={<SyncIcon />}
          color={ButtonColor.secondaryBlue}
          onClick={refreshIGConnection}
          className="ig-account-connection-status__refresh-button"
        >
          Refresh Connection
        </PrimaryButton>

        <PrimaryButton
          className="ig-account-connection-status__button"
          color={ButtonColor.invertedRed}
          onClick={onClickDisconnect}
        >
          Disconnect
        </PrimaryButton>
      </div>
    </SettingSection>
  );
};
